@if (hasLabel) {
  <label class="__label">
    <ng-content select="zef-form-label"></ng-content>
  </label>
}

<div class="__content  c-form-field-content">
  <ng-content></ng-content>
</div>

@if (hasHints) {
  <div class="__hints">
    <ng-content select="zef-form-hints"></ng-content>
  </div>
}
